export default ({
  backgroundColor: '#f6f9fb',
  headerBackgroundColor: '#5f5f5f',
  headerColor: 'rgba(249, 252, 255, 0.8)',
  headerColorActive: '#fff',
  headerFocusColor: 'rgba(249, 252, 255, 0.15)',
  sidebarBackgroundColor: '#888',
  sidebarColor: 'rgba(249, 252, 255, 0.8)',
  sidebarColorActive: '#fff',
  sidebarDarkMode: true,
  sidebarHeaderBackgroundColor: '#5f5f5f',
  sidebarHeaderColor: 'rgba(249, 252, 255, 0.8)',
  sidebarHeaderColorActive: '#fff',
  sidebarInnerBackgroundColor: 'rgba(0, 0, 0, 0.15)',
  sidebarInnerColor: 'rgba(249, 252, 255, 0.8)',
  sidebarInnerColorActive: '#fff'
});
